import * as SwitchPrimitive from '@radix-ui/react-switch'
import * as React from 'react'

import { cn } from '@/lib/utils'

function Switch({ className, ...props }: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      data-slot='switch'
      className={cn(
        'peer border-icon-default inline-flex h-[20px] w-[34px] shrink-0 items-center rounded-full border-1 bg-white p-0.5 shadow-xs transition-all outline-none',
        'focus-visible:ring-icon-defabg-icon-default/30 focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot='switch-thumb'
        className={cn(
          'pointer-events-none block size-[14px] rounded-full ring-0 transition-transform',
          'bg-icon-default',
          'data-[state=checked]:translate-x-full data-[state=unchecked]:translate-x-0',
          'rtl:data-[state=checked]:-translate-x-full rtl:data-[state=unchecked]:translate-x-0'
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
